import React from 'react';
import './AboutPage.css';
import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';

// This is one of our simplest components
// It doesn't have local state,
// It doesn't dispatch any redux actions or display any part of redux state
// or even care what the redux state is'

function AboutPage() {
  return (
    <>
    <Nav />
    <div className="about-container">
      <div className='about-text'>
      <div id='dropoff-div'>
            <h4>​<em>** TO DONATE GENTLY USED FURNITURE, YOU MAY DROP ITEMS OFF AT THE WAREHOUSE ON
              WEDNESDAY OR THURSDAY FROM 1 PM TO 5 PM CST. (CLOSED ON HOLIDAYS) **</em></h4>
          </div>
        <div id='logo-div' >
          <img src='https://www.furnituremissionrrv.org/uploads/1/2/9/3/129302823/published/11112019-amyn-logo-fc.png?1605379303' alt="Furniture Mission of the Red River Valley" />
        </div>
        <h1><strong>Our Foundational Elements</strong></h1>
        <div className='main-points'>
          <h4> <span className='points'>Vision Statement</span> - What we want to see in the world</h4>
          <p>We envision renewing and restoring hope to those individuals and families in need.</p>
        </div>
        <div className='main-points'>
          <h4> <span className='points'>Mission Statement</span> - What is our work</h4>
          <p>Our mission is to demonstrate love and compassion by connecting furniture/household items with individuals and families in their time of crisis and challenge.</p>
        </div>
        <div className='main-points'>
          <h4> <span className='points'>Purpose Statement</span> - Why we do our work</h4>
          <p>Our purpose is to fill a void in the community by helping transform a residence into a home.</p>
        </div>
        <div className='main-points'>
          <h4> <span className='points'>Our Core Values</span> - The rock of values we built upon</h4>
          <p>We are unwavering in our values as we came together to build the organization. These values are the foundation and they manifest in all development and impacts of the Furniture Mission of the Red River Valley.</p>
          <ul className='about-list'>
            <li>Respect</li>
            <li>Grace</li>
            <li>Compassion</li>
          </ul>
          <ul className='about-list'>
            <li>Generosity</li>
            <li>Integrity</li>
            <li>Humility</li>
          </ul>
        </div>
        <div className='main-points'>
          <h4> <span className='points'>Our Guiding Principles</span> - Our guide as we connect, work, build, and evolve the Furniture Mission of the Red River Valley</h4>
          <p>We take our values on step further and have established guiding principles for all of our work. We ensure that every action of the Furniture Mission of the Red River Valley is filled with love and hope.</p>
          <ul className='about-list'>
            <li>Faith-led</li>
            <li>Transparency</li>
            <li>Responsive</li>
          </ul>
          <ul className='about-list'>
            <li>Connecting</li>
            <li>Kindness</li>
            <li>Perseverance</li>
          </ul>
        </div>
      </div>
    </div>
    <Footer />
    </>
  );
}

export default AboutPage;
